// 反馈状态
export const FEEDBACK_STATUS = [
  {
    label: "未处理",
    value: "unprocessed",
  },
  {
    label: "处理中",
    value: "processing",
  },
  {
    label: "已处理",
    value: "processed",
  }
];